import styled from 'styled-components'

const StyledTextWrapper = styled.div`
  & > p {
    margin: 0;
  }
`

const loadingOverlayFirstLineStyles = {
  color: 'var(--ql-color-white)',
  fontSize: '20px',
  textAlign: 'center'
}

const loadingOverlaySecondLineStyles = {
  color: 'var(--ql-color-white)',
  fontSize: '28px'
}

export {
  loadingOverlayFirstLineStyles,
  loadingOverlaySecondLineStyles,
  StyledTextWrapper
}
